import { FormattedDate } from './FormattedDate';

type Props = {
    dateValue: string;
    className?: string;
    scopeCompanyId?: number | null;
};

export function DateDefaultNowrap({ dateValue, className, scopeCompanyId }: Props) {
    return <FormattedDate value={dateValue} fallback="" nowrap className={className} scopeCompanyId={scopeCompanyId} />;
}
